// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { MaterialFileOut } from './materialFileOut.zod.ts';

export const MaterialOut = zod.object({
  "audience": zod.string(),
  "file": zod.union([MaterialFileOut,zod.null()]),
  "id": zod.uuid(),
  "kind": zod.enum(['file', 'link']),
  "material_type": zod.string(),
  "position": zod.int(),
  "preview": zod.enum(['pdf', 'markdown', 'none']),
  "superseded_by": zod.union([zod.uuid(),zod.null()]),
  "title": zod.string(),
  "url": zod.union([zod.string(),zod.null()])
});

export type MaterialOut = zod.input<typeof MaterialOut>;
export type MaterialOutOutput = zod.output<typeof MaterialOut>;
